export default (data) => {
  const { userPreferences, updateVersion } = data;

  const updateUserPreferences = {
    ...userPreferences,
    covid19vaccinated: 'not',
    version: {
      number: updateVersion,
      updated: true,
    },
  };
  return updateUserPreferences;
};
